import type {
  CreateCustomerPurchaseCommand,
  CreateCustomerPurchaseCommandResponse,
  ReviewRequestStatusDto,
} from "@/models/club";
export type PendingInvoice = {
  key: string;
  data: CreateCustomerPurchaseCommand;
};
type Transport = {
  status: (key: string) => Promise<ReviewRequestStatusDto>;
  create: (
    data: CreateCustomerPurchaseCommand,
    key: string,
  ) => Promise<CreateCustomerPurchaseCommandResponse>;
};
export function assertSameInvoice(
  pending: PendingInvoice,
  data: CreateCustomerPurchaseCommand,
) {
  if (JSON.stringify(pending.data) !== JSON.stringify(data))
    throw new Error(
      "نتیجه فاکتور قبلی مشخص نیست؛ ابتدا وضعیت آن را بازیابی کنید.",
    );
}
export async function submitInvoice(
  pending: PendingInvoice,
  recovering: boolean,
  transport: Transport,
) {
  if (recovering) {
    try {
      const status = await transport.status(pending.key);
      if (status.status === "completed" && status.result) return status.result;
      throw new Error(
        "درخواست هنوز در حال پردازش است. کمی بعد دوباره وضعیت را بررسی کنید.",
      );
    } catch (error) {
      const failure = error as { response?: { data?: { code?: string } } };
      if (failure.response?.data?.code !== "REQUEST_NOT_FOUND") throw error;
    }
  }
  return transport.create(pending.data, pending.key);
}
